<feedback-session
	*ngIf="isFullyLoaded$$ | async"
	[user]="userService.currentUser"
	[userGroup]="(selectedService.selectedSubject | async).group"
	[license]="(selectedService.selectedSubject | async).license"
	[activity]="(selectedService.selectedSubject | async).activity"
	[options]="options$$ | async"
	[session]="(selectedService.selectedSubject | async).session"
	[feedbackMode]="$stateParams.feedbackMode"
	[viewMode]="$stateParams.viewMode"
	[orgSettings]="(selectedService.selectedSubject | async).org.org_settings">
	<feedback-session-header></feedback-session-header>
</feedback-session>
<div class="logo-container" *ngIf="(isFullyLoaded$$ | async) === false">
	<loading></loading>
</div>
